// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__FVfRm","content":"styles_content__1Gcd_","checkbox":"styles_checkbox__6o5jN","checkboxLabel":"styles_checkboxLabel__BJQ_W"};